import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18NextHttpBackend from "i18next-http-backend";
import { CLIENT_THEME } from "../utils/constants";

i18n
  .use(I18NextHttpBackend)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: window.localStorage.getItem('locale') ?? 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: Object.values(CLIENT_THEME),
    backend: {
      loadPath: (lng, namespace) => {
        if (!window.localStorage.getItem('locale')) {
            window.localStorage.setItem('locale', lng);
        }
        return `${window.location.origin}/locales/${namespace}/${lng}.json`;
      },
    },
  });

export default i18n;
